import { render, staticRenderFns } from "./DataFusion.vue?vue&type=template&id=795b22bf&scoped=true&"
import script from "./DataFusion.vue?vue&type=script&lang=js&"
export * from "./DataFusion.vue?vue&type=script&lang=js&"
import style0 from "./DataFusion.vue?vue&type=style&index=0&id=795b22bf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b22bf",
  null
  
)

export default component.exports